import { render } from "./PrimaryGoals.vue?vue&type=template&id=9a96c7d2"
import script from "./_PrimaryGoals.js?vue&type=script&lang=js&external"
export * from "./_PrimaryGoals.js?vue&type=script&lang=js&external"

import "./_PrimaryGoals.less?vue&type=style&index=0&lang=less&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__